import { useNavigate } from 'react-router-dom';
import { Scissors, ArrowLeft } from '@phosphor-icons/react';

export const PageHeader = ({ backTo, backLabel, breadcrumbs }) => {
  const navigate = useNavigate();

  return (
    <>
      <header className="salonup-header animate-fade-in">
        <div className="salonup-brand">
          <div className="salonup-logo-mark">
            <Scissors size={22} weight="bold" />
          </div>
          <span className="salonup-logo-text">Salon<span>Up</span></span>
        </div>
        
        <button 
          onClick={() => navigate(backTo)}
          data-testid="btn-back"
          className="salonup-btn-back"
        >
          <ArrowLeft size={18} weight="bold" />
          <span>{backLabel}</span>
        </button>
      </header>

      <div className="mb-4 animate-fade-in opacity-0 delay-100" style={{ animationFillMode: 'forwards' }}>
        <p className="salonup-text-xs">
          {breadcrumbs.map((crumb, i) => (
            <span key={i}>
              {i > 0 && <span className="mx-2">·</span>}
              {crumb.path ? (
                <span 
                  className="cursor-pointer hover:text-[#1B4332] transition-colors" 
                  onClick={() => navigate(crumb.path)}
                >
                  {crumb.label}
                </span>
              ) : (
                <span className="text-[#18181B] font-medium">{crumb.label}</span>
              )}
            </span>
          ))}
        </p>
      </div>
    </>
  );
};
